/**
 * 指标追踪 SDK - CDN 入口
 * 自动从 script 标签的 data-* 属性读取配置并初始化
 */

import { MetricTracker } from './core/MetricTracker';
import { MetricTrackerConfig } from './core/config';

/**
 * 从 script 标签获取配置
 */
function getConfigFromScriptTag(): MetricTrackerConfig | null {
  // 查找当前 script 标签
  const scripts = document.getElementsByTagName('script');
  let currentScript: HTMLScriptElement | null = null;

  // 尝试找到包含 metric-tracker 的 script 标签
  for (let i = 0; i < scripts.length; i++) {
    const script = scripts[i];
    if (script.src && script.src.includes('metric-tracker')) {
      currentScript = script;
      break;
    }
  }

  if (!currentScript) {
    console.error('[MetricTracker] Cannot find script tag');
    return null;
  }

  // 从 data-* 属性读取配置
  const appCode = currentScript.getAttribute('data-app-code');
  const baseUrl = currentScript.getAttribute('data-base-url');
  const debug = currentScript.getAttribute('data-debug') === 'true';

  // 读取允许的域名列表（逗号分隔）
  const allowedDomainsStr = currentScript.getAttribute('data-allowed-domains');
  const allowedDomains = allowedDomainsStr
    ? allowedDomainsStr.split(',').map(d => d.trim()).filter(d => d)
    : undefined;

  // 读取路由模式
  const routeMode = currentScript.getAttribute('data-route-mode') as 'auto' | 'history' | 'hash' | null;

  // 验证必填参数
  if (!appCode) {
    console.error('[MetricTracker] data-app-code is required');
    return null;
  }

  if (!baseUrl) {
    console.error('[MetricTracker] data-base-url is required');
    return null;
  }

  return {
    appCode,
    baseUrl,
    debug,
    allowedDomains,
    routeMode: routeMode || undefined,
  };
}

/**
 * CDN 自动初始化
 */
function initCdn(): void {
  // 确保在 DOM 加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCdn);
    return;
  }

  // 获取配置
  const config = getConfigFromScriptTag();
  if (!config) {
    return;
  }

  try {
    // 创建全局实例
    const tracker = new MetricTracker(config);
    tracker.start();

    // 挂载到 window 对象
    (window as any).__MetricTracker__ = tracker;

    // 暴露全局方法
    (window as any).metricTrack = (sourcePc: string) => {
      tracker.track(sourcePc);
    };

    if (config.debug) {
      console.log('[MetricTracker] CDN initialized successfully');
      console.log('[MetricTracker] Access via: window.__MetricTracker__');
      console.log('[MetricTracker] Track via: window.metricTrack(sourcePc)');
    }
  } catch (error) {
    console.error('[MetricTracker] CDN initialization failed:', error);
  }
}

// 立即执行初始化
initCdn();
